import { QuickView } from '../../../sections/product/quick-view'
import { debounce } from '../../../utils/debounce'
import { hideElement } from '../../../utils/dom'
import { Card } from '../card/card'
import { ColorSwatches } from './product-card-color-swatches'
import { $el, $list } from 'src/scripts/utils/utils'

const QUICK_VIEW_BUTTON_SELECTOR = '[data-product-card-quick-view-button]'
const PRELOADER_SELECTOR = '[data-product-card-preloader]'
const BUTTONS_SELECTOR = '[data-product-card-buttons]'
const FEATURED_MEDIA_SELECTOR = '[data-product-card-featured-image]'
const COLOR_SWATCHES_SELECTOR = '[data-product-card-color-swatches]'
const INNER_SELECTOR = '[data-product-card-inner]'
const QUICK_VIEW_SELECTOR = '#Quick-view'
const MAIN_MEDIA_SELECTOR = '[data-main-media]'

export class ProductCard extends Card {
  resizeObserver: ResizeObserver
  buttonsWidth: number = 0
  buttonsHeight: number = 0

  mountComponent(): void {
    const quickViewBtn = $el(QUICK_VIEW_BUTTON_SELECTOR, this)
    const featuredImages = $list(
      FEATURED_MEDIA_SELECTOR,
      this,
    ) as HTMLImageElement[]

    this.resizeObserver = new ResizeObserver(this.handleResize)
    this.resizeObserver.observe(this)

    featuredImages.forEach(featuredImage => {
      if (featuredImage.complete) {
        this.handleMediaLoad()
      } else {
        this.addListener(featuredImage, 'load', this.handleMediaLoad)
      }
    })

    this.addListener(quickViewBtn, 'click', this.handleQuickViewBtnClick)
  }

  unmountComponent(): void {
    this.resizeObserver.disconnect()
  }

  handleQuickViewBtnClick = async (): Promise<void> => {
    const quickView: QuickView = $el(QUICK_VIEW_SELECTOR)
    const url = this.dataset.url
    const id = this.dataset.id

    if (!quickView || !url || !id) {
      return
    }

    await quickView.requestProductFromUrl(url, id)
    await quickView.openAndRenderProductByUrl(url)
  }

  handleResize = debounce((): void => {
    const buttons = $el(BUTTONS_SELECTOR, this)
    const swatches: ColorSwatches = $el(COLOR_SWATCHES_SELECTOR, this)

    if (buttons) {
      this.setButtonsOverflow()
    }
    if (swatches) {
      swatches.update()
    }
  }, 250)

  handleMediaLoad = (): void => {
    const loader = $el(PRELOADER_SELECTOR, this)
    hideElement(loader)
  }

  setButtonsOverflow(): void {
    const buttons = $el(BUTTONS_SELECTOR, this)
    const inner = $el(INNER_SELECTOR, this)

    if (!buttons) {
      return
    }

    if (this.offsetWidth < this.buttonsWidth) {
      return
    }

    const isWidthOverflow = buttons.offsetWidth > inner.offsetWidth
    const isHeightOverflow = buttons.offsetHeight > inner.offsetHeight

    if (isWidthOverflow && buttons.offsetWidth > this.buttonsWidth) {
      this.buttonsWidth = buttons.offsetWidth
    }

    if (isHeightOverflow && buttons.offsetHeight > this.buttonsHeight) {
      this.buttonsHeight = buttons.offsetHeight
    }

    buttons.classList.toggle('is-width-overflowed', isWidthOverflow)
    buttons.classList.toggle('is-height-overflowed', isHeightOverflow)
  }

  getMainMedia() {
    return $el(MAIN_MEDIA_SELECTOR, this)
  }
}
